import { FragmentType, graphql, useFragment } from '@/gql'
import type { OwnerOption, OwnerSelection } from '@/components/Owners/OwnersPicker.vue'

export const OwnerUserFields = graphql(`
  fragment OwnerUserFields on User {
    id
    name
    email
    avatar
  }
`)

export const OwnerFields = graphql(`
  fragment OwnerFields on Owner {
    id
    responsibility
    user {
      id
      ...OwnerUserFields
    }
  }
`)

export const toOwnerOption = (user: FragmentType<typeof OwnerUserFields>): OwnerOption => {
  const { id, name, email, avatar } = useFragment(OwnerUserFields, user)

  return { id, value: id, label: name, email, avatar: avatar ?? null }
}

/** Keyed by the user, which is what the picker and the mutation work in. */
export const toOwnerSelection = (owner: FragmentType<typeof OwnerFields>): OwnerSelection => {
  const { user, responsibility } = useFragment(OwnerFields, owner)

  return { ...toOwnerOption(user), responsibility: responsibility ?? null }
}
